import { createContext } from 'react';
import { StateContextType } from '../../types';

const iUserContextState = {
    state: {
        page: -1,
        portalId: 0,
        appId: '',
        processor: null,
        appCode: ''
    },
    setState: () => { }
}

const StateContext = createContext<StateContextType>(iUserContextState);

export default StateContext;